/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".close[_ngcontent-%COMP%]{font-size:2rem;line-height:2rem;opacity:.3}.logo-image[_ngcontent-%COMP%]{width:60px;height:60px;position:relative;left:-7px;top:-6px}"];
export { styles as styles };
